export const ROLLBAR_INJECTION_KEY = 'rollbar'

export default {
  install: (app) => {
    const rollbar = window?.Rollbar

    if (!app.config.errorHandler) {
      app.config.errorHandler = (err, _vm, info) => {
        rollbar?.error(err, { info })
        throw err
      }
    }

    if (!rollbar) {
      console.warn('Rollbar instance not found on window. Ensure Rollbar.js is loaded in Rails.')
      return
    }

    app.provide(ROLLBAR_INJECTION_KEY, rollbar)
    app.config.globalProperties.$rollbar = rollbar
  },
}
